import React from 'react';
import { createImageUrl } from '../../helpers/commonHelpers';

const CarouselImage = (props) => {
    const { index, image, setCarouselImage, currentIndex, activeImageIndex } = props;
    /** translateX(${415 - (currentIndex * 118.5)}% */
    const styles = { 
        backgroundImage: `url("${createImageUrl(image)}")`, 
        transform: `translateX(${-((currentIndex * 118.8) - 118.8)}%) ${activeImageIndex === index ? 'scaleY(1.25)' : ''}`, 
        border: `${activeImageIndex === index ? '2px solid #EBB304' : ''}` 
    }
    return (
        <div onClick={(event) => { setCarouselImage(event, image, index) }} style={styles} className='carousel__image' />
    );
}

export default CarouselImage;